import { Location } from "@/interfaces/location";
import findIndex from "lodash/findIndex";
import forOwn from "lodash/forOwn";
import isArray from "lodash/isArray";
import reduce from "lodash/reduce";
import { PolicyModel, PolicyNode, PolicyReq } from "../declarations";

const formattedPolicies = (raw: PolicyModel, selectedLocations: Location[]) => {
  return reduce(
    raw,
    (acc: PolicyReq[], service) => {
      // Not location based policies
      if (isArray(service)) {
        const formatted = service.reduce((c: PolicyReq[], p) => {
          if (p.policy_id) {
            c.push({ id: p.policy_id });
          }
          return c;
        }, []);
        acc = [...acc, ...formatted];
      } else {
        forOwn(service, (val: PolicyNode[], locationId) => {
          if (selectedLocations.find(l => l.id === +locationId)) {
            val.forEach((policy: PolicyNode) => {
              const inAcc = findIndex(acc, p => p.id === policy.policy_id);
              if (inAcc > -1) {
                // Already selected for other location
                acc[inAcc] = {
                  ...acc[inAcc],
                  options: [
                    ...acc[inAcc].options!,
                    { location_id: +locationId, requires_authorization: null }
                  ]
                };
              } else {
                // Policy is not on accumulator, pushes new item
                if (policy.policy_id) {
                  acc.push({
                    id: policy.policy_id,
                    options: [
                      {
                        location_id: +locationId,
                        requires_authorization: null
                      }
                    ]
                  });
                }
              }
            });
          }
        });
      }
      return acc;
    },
    []
  );
};

export default formattedPolicies;
